import React from 'react';

const initialState = {
  referrerId: '',
};

const GrowsurfContext = React.createContext(initialState);

export default GrowsurfContext;
